import type { ReactNode } from "react";
import { ThemeTokenContext, type ThemeToken } from "../ui/theme";
import { themeTokenVarDeclarations } from "./themeRuntime";

export type AppConfigProviderProps = {
  /**
   * Eigener Designvertrag statt des gewählten Themes (öffentliche Widgets mit festen Werten): die Design-Tokens,
   * die `theme.useToken()` in diesem Bereich liefert, samt ihrer CSS-Variablen `--ant-*` am Dokument (der Bereich ist
   * die ganze Seite, Overlays hängen am Body). Ohne Angabe gelten die Tokens des Shared-`ThemeProvider`.
   */
  override?: { token: ThemeToken };
  children: ReactNode;
};

/**
 * Wurzel der Oberflächeneinstellungen jeder App (Plan 2026-10-14, T3; seit Stufe 8 des Plans 2026-10-13 ohne Antd):
 * Die Kit-Bausteine lesen Theme, Feldform und Sprache selbst (`--mq-theme-*`, `data-theme-field`,
 * `UiLanguageProvider`); hier bleibt nur der eigene Designvertrag einzelner Bereiche.
 */
export function AppConfigProvider({ override, children }: AppConfigProviderProps) {
  if (!override) return <>{children}</>;
  return (
    <ThemeTokenContext.Provider value={override.token}>
      <style>{`:root{${themeTokenVarDeclarations(override.token)}}`}</style>
      {children}
    </ThemeTokenContext.Provider>
  );
}
